/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".annualCost[_ngcontent-%COMP%]{font-size:16px}.feeAmount[_ngcontent-%COMP%]{font-size:20px}.tagPprocessingFee[_ngcontent-%COMP%]   .feeAmount[_ngcontent-%COMP%]{font-size:18px}.description[_ngcontent-%COMP%]{font-size:14px;padding-bottom:6px;color:#000;line-height:15px}.showMore[_ngcontent-%COMP%]{font-size:14px;padding-left:9px;line-height:18px;padding-right:10px}.hdPlate[_ngcontent-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;padding-bottom:6px}"];
export { styles as styles };
